import s from './style.css';
import Chapter from 'components/Chapter';
import TextComparison from 'components/TextComparison';
import SliceChart from 'components/SliceChart';
import EmojiGraph from 'components/EmojiGraph';
import AreaComparison from 'components/AreaComparison';
import RadialChart from 'components/RadialChart';
import ChartTitle from 'components/ChartTitle';
import LookCloser from 'components/LookCloser';
import CircleGraph from 'components/CircleGraph';
import ScaledPullOut from 'components/ScaledPullOut';
import InView from 'components/InView';

import {
	title,
	standfirst,
	viz1Title,
	viz1,
	viz2Title,
	viz2,
	viz3Title,
	viz3,
	viz4Title,
	viz4Subtitle,
	viz4,
	viz5Title,
	viz5,
	viz6Title,
	viz6Subtitle,
	viz6,
	viz6Text1,
	viz6Text2,
	viz6Emoji
} from 'copy/physical.txt';

const PhysicalChanges = () => (
	<Chapter
		section={2}
		title={title}
		standFirst={standfirst}
		highlight={['52%']}
	>
		<ChartTitle tag="h3" flush>
			{viz1Title}
		</ChartTitle>
		<InView
			render={inView => (
				<RadialChart
					data={viz1}
					includePercentage
					fill={'#82DEBC'}
					max={50}
					inView={inView}
				/>
			)}
		/>
		<LookCloser />
		<InView
			render={inView => (
				<SliceChart
					data={viz2}
					copy={viz2Title}
					inView={inView}
					highlight={['LGBTQ\\+']}
					highlightColors={['#FECA98']}
				/>
			)}
		/>

		<ChartTitle tag="h3" flush>
			{viz3Title}
		</ChartTitle>
		<InView
			render={inView => (
				<AreaComparison
					data={viz3}
					masterCirclePercentage="100"
					inView={inView}
				/>
			)}
		/>

		<ChartTitle tight tag="h3">
			{viz4Title}
		</ChartTitle>
		<ChartTitle tag="p">{viz4Subtitle}</ChartTitle>
		<InView
			render={inView => (
				<CircleGraph data={viz4} isAlternative inView={inView} />
			)}
		/>
		<LookCloser sized />

		<InView
			render={inView => (
				<ScaledPullOut
					max={100}
					copy={viz5Title}
					data={viz5}
					inView={inView}
					highlight={['women', 'men']}
					highlightColors={['#17ADA1', '#B3F36C']}
				/>
			)}
		/>

		<ChartTitle tag="h3">{viz6Title}</ChartTitle>
		<ChartTitle tag="p">{viz6Subtitle}</ChartTitle>
		<p className={s.tight}>{viz6Text1}</p>
		<TextComparison
			snugPadding
			items={viz6.map(({ fact, number }) => `${number} ${fact}`)}
		/>
		<p className={s.tight}>{viz6Text2}</p>
		<InView
			render={inView => (
				<EmojiGraph data={viz6} emoji={viz6Emoji} isEnd inView={inView} />
			)}
		/>
	</Chapter>
);

export default PhysicalChanges;



// WEBPACK FOOTER //
// ./components/PhysicalChanges/index.js